import { useState, useEffect } from 'react';
import { control } from '../service';

export const useControl = (observerName: string) => {
  const [data, setData] = useState({
    showWarning: false,
    fullView: false,
    showHeader: false,
    showLeftMenu: false,
    showSideBar: false,
    showFooter: false,
  });

  useEffect(() => {
    // flag to prevent calling setData when the component is unmounted
    let finished = false;

    // must set the state right here and right now because the login/signup
    // may have been already configured and we missed the notification
    setData({
      showWarning: control.state.showWarning,
      fullView: control.state.fullView,
      showHeader: control.state.showHeader,
      showLeftMenu: control.state.showLeftMenu,
      showSideBar: control.state.showSideBar,
      showFooter: control.state.showFooter,
    });

    // now we can listen to further notifications, if any
    const unsubscribe = control.subscribe(() => {
      if (!finished) {
        setData({
          showWarning: control.state.showWarning,
          fullView: control.state.fullView,
          showHeader: control.state.showHeader,
          showLeftMenu: control.state.showLeftMenu,
          showSideBar: control.state.showSideBar,
          showFooter: control.state.showFooter,
        });
      }
    }, observerName);

    // return clean-up function
    return () => {
      finished = true;
      unsubscribe();
    };

    // note dependencies
  }, [observerName]);

  return data;
};
